import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'


import Button from '@shared/ui/button'

import styles from './styles.module.scss'


interface EmptyPopoverProps {
  onGoToCatalog?: () => void;
}

export default function EmptyPopover (props: EmptyPopoverProps) {
  const { onGoToCatalog } = props
  const { t: ts } = useTranslation('search')

  const handleCatalogClick = useCallback(() => {
    onGoToCatalog?.()
  }, [ onGoToCatalog ])

  return (
    <div className={styles.root}>
      <h3 className={styles.root__title}>
        {ts('empty.title2')}
      </h3>
      <p className={styles.root__desc}>
        {ts('empty.description3')}
      </p>
      <Button
        className={styles.root__button}
        theme="secondary"
        onClick={handleCatalogClick}
      >
        {ts('empty.goBtn')}
      </Button>
    </div>
  )
}